import type { Topic } from "./api";
import type { CatalogChoice } from "./generator-filter";

export function topicGenerators(topic: Topic, grade?: number): CatalogChoice[] {
  const ids = topic.generator_skill_ids?.length ? topic.generator_skill_ids : topic.generator_skill_id ? [topic.generator_skill_id] : [];
  return [...new Set(ids)].flatMap(skillId => {
    const skillGrade = Number(skillId.match(/\.g(\d+)\./)?.[1]);
    if (!skillGrade || (grade && skillGrade !== grade)) return [];
    const label = topic.generator_labels?.[skillId] ?? topic.generator_candidate_labels?.[skillId];
    // Never show an internal ID as a substitute for a missing public label.
    return label ? [{skillId, label, grade:skillGrade, subject:topic.subject_id}] : [];
  });
}

export function catalogGenerators(topics: Topic[]): CatalogChoice[] {
  return [...new Map(topics.flatMap(t=>topicGenerators(t)).map(c=>[c.skillId,c])).values()];
}

export function generatorLink(choice: CatalogChoice) {
  return {pathname:"/generate" as const,query:{skill:choice.skillId,grade:choice.grade,subject:choice.subject}};
}
